<section class="partners">
  <div class="title" i18n="home partners: title">Our <span class="position-relative" style="font-family: 'Poppins Bold';">Partners<img
        class="position-absolute" style="left: 0;
bottom: -16px;
width: 100%;" src="./assets/lines/3.png" alt=""></span></div>
  <div class="container d-flex align-items-center h-100 px-3">
    <swiper #swiperPartners [config]="partnersConfig" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()">
      <ng-template swiperSlide>
        <a href="https://uom.lk/" target="_blank">
          <div class="partner-box" style="background-image: url('./assets/images/partners/moratuwa.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/moratuwa.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: uom">University of Moratuwa</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.microsoft.com/en-lk" target="_blank">
          <div class="partner-box" style="background-image: url('./assets/images/partners/ms.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/ms.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: ms">Microsoft Corporation</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.kln.ac.lk/" target="_blank">
          <div class="partner-box" style="background-image: url('./assets/images/partners/uok.png');">
            <!-- <img height="50px" width="auto"  alt=""> -->
          </div>
          <div class="name" i18n="home partners: uok">University of Kelaniya</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.ruh.ac.lk/index.php/en/" target="_blank">
          <div class="partner-box" style="background-image: url('./assets/images/partners/uor.jpg');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: uor">University of Ruhuna</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.unicef.org/" target="_blank">
          <div class="partner-box-horizontal" style="background-image: url('./assets/images/partners/unicef.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: unicef">UNICEF</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.kiu.ac.lk/" target="_blank">
          <div class="partner-box" style="background-image: url('./assets/images/partners/kiu.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: kaatsu">KAATSU International University Sri Lanka</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.ageoflearning.com/" target="_blank">
          <div class="partner-box-horizontal" style="background-image: url('./assets/images/partners/aol.jpg');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: aol">Age of Learning</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://www.treetag.in/" target="_blank">
          <div class="partner-box-horizontal" style="background-image: url('./assets/images/partners/tree-tag.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: tree-tag">Tree Tag</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a href="https://web.facebook.com/profile.php?id=100092325627547&mibextid=LQQJ4d&_rdc=1&_rdr" target="_blank">
          <div class="partner-box-horizontal" style="background-image: url('./assets/images/partners/planet-protectors.png');">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: planet-protectors">Planet Protectors</div>
        </a>
      </ng-template>
      <ng-template swiperSlide>
        <a [href]="locale === 'en' ? 'https://www.hithawathi.lk/' : locale === 'ta' ? 'https://www.hithawathi.lk/ta/hithawathi-ta/' : 'https://www.hithawathi.lk/si/hithawathi-si/'" target="_blank">
          <div [ngClass]="locale === 'en' ? 'partner-box' : 'partner-box-horizontal'" [ngStyle]="{'background-image': 'url(./assets/images/partners/' + (locale === 'en' ? 'Hithawathi.jpg' : locale === 'ta' ? 'Hithawathi-ta.jpg' : 'Hithawathi-si.jpg') + ')'}">
            <!-- <img height="50px" width="auto" src="./assets/images/partners/kiu.png" alt=""> -->
          </div>
          <div class="name" i18n="home partners: hithawathi">Hithawathi</div>
        </a>
      </ng-template>
    </swiper>
  </div>
</section>